module.exports = __webpack_public_path__ + "img/PS41.696d9f1c.png";